export default "__VITE_ASSET__BUW68ol4__"